module.exports = __webpack_public_path__ + "static/img/weixing.b5da693.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/remote/weixing.jpg
// module id = 6cEb
// module chunks = 1